import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Nav from "../Components/Nav";
import { auth, db } from "../config"; // db = Firestore instance
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const [userData, setUserData] = useState({ myReferralId: "", referreduserid: "nnnnn", fullname: "Unknown" });
  const [investments, setInvestments] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          // Fetch user data
          const userRef = doc(db, "users", user.uid);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            setUserData(userSnap.data());
          } else {
            console.log("No such user document!");
          }

          // Fetch investments
          const q = query(
            collection(db, "investments"),
            where("userId", "==", user.uid)
          );
          const querySnapshot = await getDocs(q);
          const fetched = querySnapshot.docs.map((doc) => doc.data());
          setInvestments(fetched);
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      } else {
        console.log("No user logged in");
        navigate("/");
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  // Handle copy referral link
  const handleCopyLink = () => {
    const referralLink = `https://trueledgerassist.com/auth/register.html?referralid=${userData.myReferralId}`;
    navigator.clipboard
      .writeText(referralLink)
      .then(() => {
        alert("Referral link copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const accountBalance = userData?.balance || 0.0;
  const totalProfit = userData?.totalprofit || 0.0;
  const totalDeposits = userData?.Totaldeposit || 0.0;
  const referralBonus = userData?.total_referral_comissions || 0.0;

  // if (loading) {
  //   return <div>Loading...</div>;
  // }

  return (
    <div>
      <div className="wrapper">
        <Nav />
        <div className="main-panel bg-light">
          <div className="content bg-light">
            <div className="page-inner">
              <div className="mt-2 mb-4">
                <div className="user-info">
                  <h5 className="text-dark pt-4" style={{ color: "red" }}>
                    Hello!{" "}
                    <span className="username">
                      {userData?.fullname || "User"}
                    </span>
                  </h5>
                  <h5 className="text-dark pt-4" style={{ color: "red" }}>
                    Account Funds:{" "}
                    <span className="username">
                      ${accountBalance.toFixed(2)}
                    </span>
                  </h5>
                </div>
              </div>
              <strong>Click to copy referral link:</strong>
              <div className="mb-3 input-group">
                <input
                  type="text"
                  className="form-control myInput readonly text-dark bg-light"
                  value={`https://trueledgerassist.com/auth/register?referralid=${userData.myReferralId}`}
                  id="myInput"
                  readOnly
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handleCopyLink}
                    type="button"
                    id="button-addon2"
                  >
                    <i className="fas fa-copy" />
                  </button>
                </div>
              </div>
              <div
                className="livecoinwatch-widget-5"
                lcw-base="USD"
                lcw-color-tx="#999999"
                lcw-marquee-1="coins"
                lcw-marquee-2="movers"
                lcw-marquee-items={10}
              />
              <div className="row">
                <div className="col-sm-6 col-lg-3">
                  <div
                    className="p-3 card bg-cardlight shadow"
                    style={{
                      background:
                        "linear-gradient(0deg, rgba(8, 32, 50, 0.9), rgba(8, 32, 50, 0.9)), url(/home/herofx.png), #082032",
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <div>
                        <h4 className="mb-1 text-dark">
                          <b>${accountBalance.toFixed(2)}</b>
                        </h4>
                        <small className="text-muted">Account Balance</small>
                      </div>
                      <div className="ml-auto">
                        <span className="h1 text-secondary">
                          <i
                            className="far fa-money-bill-alt"
                            style={{ color: "#fff" }}
                          />
                        </span>
                      </div>
                    </div>
                    <span className="text-success d-block mt-3">
                      <a href="/auth/dashboard/deposits">Deposit</a>
                    </span>
                  </div>
                </div>
                <div className="col-sm-6 col-lg-3">
                  <div
                    className="p-3 card bg-cardlight shadow"
                    style={{
                      background:
                        "linear-gradient(0deg, rgba(8, 32, 50, 0.9), rgba(8, 32, 50, 0.9)), url(/home/herofx.png), #082032",
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <div>
                        <h4 className="mb-1 text-dark">
                          <b>${totalProfit.toFixed(2)}</b>
                        </h4>
                        <small className="text-muted text-dark">
                          Total Profit
                        </small>
                      </div>
                      <div className="ml-auto">
                        <span className="h1 text-success">
                          <i
                            className="fab fa-bitcoin"
                            style={{ color: "#fff" }}
                          />
                        </span>
                      </div>
                    </div>
                    <span className="text-success d-block mt-3">
                      <a href="/auth/dashboard/buy-plan">Buy Plan</a>
                    </span>
                  </div>
                </div>
                <div className="col-sm-6 col-lg-3">
                  <div
                    className="p-3 card bg-cardlight shadow"
                    style={{
                      background:
                        "linear-gradient(0deg, rgba(8, 32, 50, 0.9), rgba(8, 32, 50, 0.9)), url(/home/herofx.png), #082032",
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <div>
                        <h5 className="mb-1 text-dark">
                          ${totalDeposits.toFixed(2)}
                        </h5>
                        <small className="text-muted text-dark">
                          Total Deposits
                        </small>
                      </div>
                      <div className="ml-auto">
                        <span className="h1 text-success">
                          <i
                            className="fas fa-laptop-code"
                            style={{ color: "#fff" }}
                          />
                        </span>
                      </div>
                    </div>
                    <span className="text-success d-block mt-3">
                      <a href="/auth/dashboard/withdrawal">Withdraw Funds</a>
                    </span>
                  </div>
                </div>
                <div className="col-sm-6 col-lg-3">
                  <div
                    className="p-3 card bg-cardlight shadow"
                    style={{
                      background:
                        "linear-gradient(0deg, rgba(8, 32, 50, 0.9), rgba(8, 32, 50, 0.9)), url(/home/herofx.png), #082032",
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <div>
                        <h4 className="mb-1 text-dark">
                          <b>${referralBonus.toFixed(2)}</b>
                        </h4>
                        <small className="text-muted text-dark">
                          Total Referral Bonus
                        </small>
                      </div>
                      <div className="ml-auto">
                        <span className="h1 text-info">
                          <i
                            className="fas fa-archive"
                            style={{ color: "#fff" }}
                          />
                        </span>
                      </div>
                    </div>
                    <span className="text-success d-block mt-3">
                      <a href="/auth/dashboard/referuser">View Referrals</a>
                    </span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="pt-1 col-12">
                  <div className="tradingview-widget-container">
                    <iframe
                      title="Symbol Overview TradingView Widget"
                      lang="en"
                      id="tradingview_d7e6f"
                      frameBorder={0}
                      allowTransparency="true"
                      scrolling="no"
                      src="https://s.tradingview.com/embed-widget/symbol-overview/?locale=en#%7B%22symbols%22%3A%5B%5B%22Google%22%2C%22GOOGL%22%5D%2C%5B%22Apple%22%2C%22AAPL%22%5D%2C%5B%22Microsoft%22%2C%22MSFT%22%5D%5D%2C%22width%22%3A%22100%25%22%2C%22height%22%3A%22400px%22%2C%22colorTheme%22%3A%22dark%22%2C%22gridLineColor%22%3A%22%23F0F3FA%22%2C%22fontColor%22%3A%22%23787B86%22%2C%22chartType%22%3A%22area%22%2C%22lineColor%22%3A%22rgba(254%2C%2065%2C%2060%2C%201)%22%2C%22topColor%22%3A%22rgba(254%2C%2065%2C%2060%2C%200)%22%2C%22isTransparent%22%3Atrue%2C%22page-uri%22%3A%22primeMiningNetwork.com%2Fen-us%22%2C%22utm_source%22%3A%22primeMiningNetwork.com%22%2C%22utm_medium%22%3A%22widget%22%2C%22utm_campaign%22%3A%22symbol-overview%22%7D"
                      style={{
                        margin: "0px !important",
                        padding: "0px !important",
                        width: "100%",
                        height: "400px",
                      }}
                    />
                  </div>
                </div>
              </div>
              <br />

              {/* LATEST WITHDRAWALS 
              
              LATEST WITHDRAWALS 
              
              LATEST WITHDRAWALS 
              
              LATEST WITHDRAWALS  */}
              <div className="row">
                <div className="pt-1 col-12">
                  <div className="custom-container-dark mt-5">
                    {/* LATEST WITHDRAWAL STARTS  */}
                    <div className="section-full  p-t80 p-b80 bg-gray mb-5">
                      {/* TITLE START*/}
                      <div className="section-head text-center">
                        <span className="wt-title-subline font-16 text-gray-dark m-b15" />
                        <h3 className="text-uppercase">Latest Withdrawals</h3>
                        <div className="wt-separator-outer">
                          <div className="wt-separator bg-primary" />
                        </div>
                        <p />
                      </div>
                      {/* TITLE ENDS */}
                      <div
                        className="table-responsive"
                        style={{
                          height: "400px",
                          overflowY: "auto",
                          overflowX: "auto",
                        }}
                      >
                        <marquee direction="down" height="100%">
                          <table className="table" style={{ width: "100%" }}>
                            <thead>
                              <tr>
                                <th className="text-center">Status</th>
                                <th className="text-center">Amount(USD)</th>
                                <th className="text-center">Wallet</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$10,000.00</td>
                                <td className="text-center">
                                  3a17c5984af22cd7a443f14457841b3b19a51ea75a30e18bc6a82e4f8732dbca
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button className="btn btn-warning btn-sm">
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-exclamation-circle fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="far"
                                        data-icon="exclamation-circle"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm42-104c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42zm-81.37-211.401l6.8 136c.319 6.387 5.591 11.401 11.985 11.401h41.17c6.394 0 11.666-5.014 11.985-11.401l6.8-136c.343-6.854-5.122-12.599-11.985-12.599h-54.77c-6.863 0-12.328 5.745-11.985 12.599z"
                                        ></path>
                                      </svg>
                                      {/* <i class="far fa-exclamation-circle"></i> */}
                                    </span>
                                    Pending
                                  </button>
                                </td>
                                <td className="text-center">$51,000.00</td>
                                <td className="text-center">
                                  8a2b9781aa4995625af7d2b008f020ac74e7e0d2a599e93ed995f7c3bc2be9f2
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$24,100.00</td>
                                <td className="text-center">
                                  f007e92cc9f82ba9c8c40c481eec7315fa9abcd85e7249a6cb57e38a2cf22d3e
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button className="btn btn-info btn-sm">
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$4,000.00</td>
                                <td className="text-center">
                                  8a2b9781aa4995625af7d2b008f020ac74e7e0d2a599e93ed995f7c3bc2be9f2
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$500</td>
                                <td className="text-center">
                                  00db85ef40da34f3ea76aa60f0b2053eec2d90121e450791c18d8edbfedde6f1
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$240,000</td>
                                <td className="text-center">
                                  b21a418a44ed8b56118facefe7aa8d26541dff811b8a8ca65cfa1346d62c5c48
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button className="btn btn-warning btn-sm">
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-exclamation-circle fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="far"
                                        data-icon="exclamation-circle"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm42-104c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42zm-81.37-211.401l6.8 136c.319 6.387 5.591 11.401 11.985 11.401h41.17c6.394 0 11.666-5.014 11.985-11.401l6.8-136c.343-6.854-5.122-12.599-11.985-12.599h-54.77c-6.863 0-12.328 5.745-11.985 12.599z"
                                        ></path>
                                      </svg>
                                      {/* <i class="far fa-exclamation-circle"></i> */}
                                    </span>
                                    Pending
                                  </button>
                                </td>
                                <td className="text-center">$51,000</td>
                                <td className="text-center">
                                  6a49e66a66f75e72e6bd383ac798792af204a6693708912ad0d48e363a2ab7a7
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$21,000</td>
                                <td className="text-center">
                                  8a2b9781aa4995625af7d2b008f020ac74e7e0d2a599e93ed995f7c3bc2be9f2
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button className="btn btn-warning btn-sm">
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-exclamation-circle fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="far"
                                        data-icon="exclamation-circle"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm42-104c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42zm-81.37-211.401l6.8 136c.319 6.387 5.591 11.401 11.985 11.401h41.17c6.394 0 11.666-5.014 11.985-11.401l6.8-136c.343-6.854-5.122-12.599-11.985-12.599h-54.77c-6.863 0-12.328 5.745-11.985 12.599z"
                                        ></path>
                                      </svg>
                                      {/* <i class="far fa-exclamation-circle"></i> */}
                                    </span>
                                    Pending
                                  </button>
                                </td>
                                <td className="text-center">$6,000</td>
                                <td className="text-center">
                                  797ba039291417fdbdb411ea0a102d23090cde9ac7799ff605f40b5db484891d
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$9,000</td>
                                <td className="text-center">
                                  f0b66ce7a33bbc63bf50050beaf52be71709c359aa1d344bb90f943690485661
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$23,000</td>
                                <td className="text-center">
                                  2083e95ada3c584471ba5982e16c5dc2a6e464d3c170555ea8c708668be9383b
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$51,000</td>
                                <td className="text-center">
                                  8a2b9781aa4995625af7d2b008f020ac74e7e0d2a599e93ed995f7c3bc2be9f2
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$5,000</td>
                                <td className="text-center">
                                  8a2b9781aa4995625af7d2b008f020ac74e7e0d2a599e93ed995f7c3bc2be9f2
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">5,000</td>
                                <td className="text-center">
                                  15c3a97edbd606bd1e455aa2875677f5c6cd2b804e9054e898f640d313e39781
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button className="btn btn-warning btn-sm">
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-exclamation-circle fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="far"
                                        data-icon="exclamation-circle"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm42-104c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42zm-81.37-211.401l6.8 136c.319 6.387 5.591 11.401 11.985 11.401h41.17c6.394 0 11.666-5.014 11.985-11.401l6.8-136c.343-6.854-5.122-12.599-11.985-12.599h-54.77c-6.863 0-12.328 5.745-11.985 12.599z"
                                        ></path>
                                      </svg>
                                      {/* <i class="far fa-exclamation-circle"></i> */}
                                    </span>
                                    Pending
                                  </button>
                                </td>
                                <td className="text-center">$18,000</td>
                                <td className="text-center">
                                  66c13496e9d53a2402fd49bbe91df298164472679cc868bbfebbabb4844d784c
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$2,500</td>
                                <td className="text-center">
                                  ce972a6b82135fcba0890ea0c8668bdddf782fd580672daa6616c3b1af40ca9f
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$9,000</td>
                                <td className="text-center">
                                  376e809b02e6ef044f6d5cf5b72111f25f3c3e16a93dce865a178e2e0f5c484c
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button className="btn btn-warning btn-sm">
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-exclamation-circle fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="far"
                                        data-icon="exclamation-circle"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm42-104c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42zm-81.37-211.401l6.8 136c.319 6.387 5.591 11.401 11.985 11.401h41.17c6.394 0 11.666-5.014 11.985-11.401l6.8-136c.343-6.854-5.122-12.599-11.985-12.599h-54.77c-6.863 0-12.328 5.745-11.985 12.599z"
                                        ></path>
                                      </svg>
                                      {/* <i class="far fa-exclamation-circle"></i> */}
                                    </span>
                                    Pending
                                  </button>
                                </td>
                                <td className="text-center">$43,000</td>
                                <td className="text-center">
                                  aa14458f8082d9c4265ef491ca0b5d4801c16bbf7a4aece7b70a0b4824ffdfea
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$10,000.00</td>
                                <td className="text-center">
                                  3a17c5984af22cd7a443f14457841b3b19a51ea75a30e18bc6a82e4f8732dbca
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button className="btn btn-warning btn-sm">
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-exclamation-circle fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="far"
                                        data-icon="exclamation-circle"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm42-104c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42zm-81.37-211.401l6.8 136c.319 6.387 5.591 11.401 11.985 11.401h41.17c6.394 0 11.666-5.014 11.985-11.401l6.8-136c.343-6.854-5.122-12.599-11.985-12.599h-54.77c-6.863 0-12.328 5.745-11.985 12.599z"
                                        ></path>
                                      </svg>
                                      {/* <i class="far fa-exclamation-circle"></i> */}
                                    </span>
                                    Pending
                                  </button>
                                </td>
                                <td className="text-center">$51,000.00</td>
                                <td className="text-center">
                                  8a2b9781aa4995625af7d2b008f020ac74e7e0d2a599e93ed995f7c3bc2be9f2
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$24,100.00</td>
                                <td className="text-center">
                                  f007e92cc9f82ba9c8c40c481eec7315fa9abcd85e7249a6cb57e38a2cf22d3e
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button className="btn btn-info btn-sm">
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$4,000.00</td>
                                <td className="text-center">
                                  8a2b9781aa4995625af7d2b008f020ac74e7e0d2a599e93ed995f7c3bc2be9f2
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$500</td>
                                <td className="text-center">
                                  00db85ef40da34f3ea76aa60f0b2053eec2d90121e450791c18d8edbfedde6f1
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$240,000</td>
                                <td className="text-center">
                                  b21a418a44ed8b56118facefe7aa8d26541dff811b8a8ca65cfa1346d62c5c48
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$17,000</td>
                                <td className="text-center">
                                  1e652d2899a1d058a20041a9faaeb5dc009101ca412ff09c387e6b281bd1db8b
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button className="btn btn-warning btn-sm">
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-exclamation-circle fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="far"
                                        data-icon="exclamation-circle"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm42-104c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42zm-81.37-211.401l6.8 136c.319 6.387 5.591 11.401 11.985 11.401h41.17c6.394 0 11.666-5.014 11.985-11.401l6.8-136c.343-6.854-5.122-12.599-11.985-12.599h-54.77c-6.863 0-12.328 5.745-11.985 12.599z"
                                        ></path>
                                      </svg>
                                      {/* <i class="far fa-exclamation-circle"></i> */}
                                    </span>
                                    Pending
                                  </button>
                                </td>
                                <td className="text-center">$51,000</td>
                                <td className="text-center">
                                  6a49e66a66f75e72e6bd383ac798792af204a6693708912ad0d48e363a2ab7a7
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$21,000</td>
                                <td className="text-center">
                                  8a2b9781aa4995625af7d2b008f020ac74e7e0d2a599e93ed995f7c3bc2be9f2
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button className="btn btn-warning btn-sm">
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-exclamation-circle fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="far"
                                        data-icon="exclamation-circle"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm42-104c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42zm-81.37-211.401l6.8 136c.319 6.387 5.591 11.401 11.985 11.401h41.17c6.394 0 11.666-5.014 11.985-11.401l6.8-136c.343-6.854-5.122-12.599-11.985-12.599h-54.77c-6.863 0-12.328 5.745-11.985 12.599z"
                                        ></path>
                                      </svg>
                                      {/* <i class="far fa-exclamation-circle"></i> */}
                                    </span>
                                    Pending
                                  </button>
                                </td>
                                <td className="text-center">$6,000</td>
                                <td className="text-center">
                                  797ba039291417fdbdb411ea0a102d23090cde9ac7799ff605f40b5db484891d
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$9,000</td>
                                <td className="text-center">
                                  f0b66ce7a33bbc63bf50050beaf52be71709c359aa1d344bb90f943690485661
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$23,000</td>
                                <td className="text-center">
                                  2083e95ada3c584471ba5982e16c5dc2a6e464d3c170555ea8c708668be9383b
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$51,000</td>
                                <td className="text-center">
                                  8a2b9781aa4995625af7d2b008f020ac74e7e0d2a599e93ed995f7c3bc2be9f2
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$5,000</td>
                                <td className="text-center">
                                  8a2b9781aa4995625af7d2b008f020ac74e7e0d2a599e93ed995f7c3bc2be9f2
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">5,000</td>
                                <td className="text-center">
                                  15c3a97edbd606bd1e455aa2875677f5c6cd2b804e9054e898f640d313e39781
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button className="btn btn-warning btn-sm">
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-exclamation-circle fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="far"
                                        data-icon="exclamation-circle"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm42-104c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42zm-81.37-211.401l6.8 136c.319 6.387 5.591 11.401 11.985 11.401h41.17c6.394 0 11.666-5.014 11.985-11.401l6.8-136c.343-6.854-5.122-12.599-11.985-12.599h-54.77c-6.863 0-12.328 5.745-11.985 12.599z"
                                        ></path>
                                      </svg>
                                      {/* <i class="far fa-exclamation-circle"></i> */}
                                    </span>
                                    Pending
                                  </button>
                                </td>
                                <td className="text-center">$18,000</td>
                                <td className="text-center">
                                  66c13496e9d53a2402fd49bbe91df298164472679cc868bbfebbabb4844d784c
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$2,500</td>
                                <td className="text-center">
                                  ce972a6b82135fcba0890ea0c8668bdddf782fd580672daa6616c3b1af40ca9f
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button
                                    className="btn
                            btn-info btn-sm"
                                  >
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-check fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fa"
                                        data-icon="check"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                                        ></path>
                                      </svg>
                                      {/* <i class="fa
                            fa-check"></i> */}
                                    </span>
                                    Confirmed
                                  </button>
                                </td>
                                <td className="text-center">$9,000</td>
                                <td className="text-center">
                                  376e809b02e6ef044f6d5cf5b72111f25f3c3e16a93dce865a178e2e0f5c484c
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center">
                                  <button className="btn btn-warning btn-sm">
                                    <span className="btn-label">
                                      <svg
                                        className="svg-inline--fa fa-exclamation-circle fa-w-16"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="far"
                                        data-icon="exclamation-circle"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        data-fa-i2svg
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm42-104c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42zm-81.37-211.401l6.8 136c.319 6.387 5.591 11.401 11.985 11.401h41.17c6.394 0 11.666-5.014 11.985-11.401l6.8-136c.343-6.854-5.122-12.599-11.985-12.599h-54.77c-6.863 0-12.328 5.745-11.985 12.599z"
                                        ></path>
                                      </svg>
                                      {/* <i class="far fa-exclamation-circle"></i> */}
                                    </span>
                                    Pending
                                  </button>
                                </td>
                                <td className="text-center">$43,000</td>
                                <td className="text-center">
                                  aa14458f8082d9c4265ef491ca0b5d4801c16bbf7a4aece7b70a0b4824ffdfea
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </marquee>
                      </div>
                    </div>
                  </div>
                  {/* LATEST WITHDRAWALS ENDS  */}
                </div>
              </div>

              {/* LATEST WITHDRAWALS 
              
              LATEST WITHDRAWALS 
              
              LATEST WITHDRAWALS 
              
              LATEST WITHDRAWALS  */}
              <div className="row">
                <div className="pt-1 col-12">
                  <h3 style={{ textAlign: "center" }}>COINTELEGRAPH NEWS</h3>
                </div>
              </div>
              <br />
            </div>
            <div className="footer-block">
              <div className="container">
                <div className="row">
                  <div className="col-6 col-md-4 mb-3 mb-md-0">
                    <div className="foot-header">Company</div>
                    <div className="foot-body">
                      <a
                        href="https://trueledgerassist.com/auth/auth/dashboard/buy-plan"
                        className="foot"
                      >
                        Investment Plans
                      </a>
                      <a href="/about.html" className="foot">
                        About Us
                      </a>
                      <a
                        href="https://www.google.com/maps?ll=-27.382143,152.993196&z=9&t=m&hl=en&gl=NG&mapclient=embed&q=Brisbane+Queensland+Australia"
                        className="foot"
                      >
                        <b>Australia Address:</b> Brisbane
                      </a>
                      <a href="/contact.html" className="foot">
                        Contact us
                      </a>
                    </div>
                  </div>
                  <div className="col-6 col-md-2 mb-3 mb-md-0">
                    <div className="foot-header">Platforms</div>
                    <div className="foot-body">
                      <a
                        href="https://trueledgerassist.com/auth/auth/login"
                        className="foot"
                      >
                        Platforms
                      </a>
                      <a
                        href="https://trueledgerassist.com/auth/auth/login"
                        className="foot"
                      >
                        MT4 for Windows
                      </a>
                      <a
                        href="https://trueledgerassist.com/auth/auth/login"
                        className="foot"
                      >
                        MT4 for iOS
                      </a>
                      <a
                        href="https://trueledgerassist.com/auth/auth/login"
                        className="foot"
                      >
                        MT4 for Android
                      </a>
                      <a
                        href="https://mine.mql5.com/mine?servers=-Demo%2CprimeMiningNetwork-Live&mine_server=primeMiningNetwork-Demo&demo_server=primeMiningNetwork-Demo&startup_mode=open_demo&lang=en"
                        className="foot"
                      >
                        Web miner
                      </a>
                    </div>
                  </div>
                  <div className="col-6 col-md-2 mb-3 mb-md-0">
                    <div className="foot-header">Trading</div>
                    <div className="foot-body">
                      <a
                        href="https://trueledgerassist.com/auth/auth/register"
                        className="foot"
                      >
                        Open Live Account
                      </a>
                      <a
                        href="https://trueledgerassist.com/auth/auth/login"
                        className="foot"
                      >
                        Instruments
                      </a>
                      <a
                        href="https://trueledgerassist.com/auth/auth/login"
                        className="foot"
                      >
                        Leaderboard
                      </a>
                      <a
                        href="https://trueledgerassist.com/auth/auth/login"
                        className="foot"
                      >
                        Market Analysis
                      </a>
                    </div>
                  </div>
                  <div className="col-6 col-md-2 mb-3 mb-md-0">
                    <div className="foot-header">Funding</div>
                    <div className="foot-body">
                      <a
                        href="https://trueledgerassist.com/auth/auth/login"
                        className="foot"
                      >
                        Funding Methods
                      </a>
                      <a
                        href="https://trueledgerassist.com/auth/auth/login"
                        className="foot"
                      >
                        Clients Protection
                      </a>
                    </div>
                  </div>
                  <div className="col-6 col-md-2 mb-3 mb-md-0">
                    <div className="foot-header">Legal</div>
                    <div className="foot-body">
                      <a href="#" className="foot">
                        AML Policy
                      </a>
                      <a href="#" className="foot">
                        Cookie Policy
                      </a>
                      <a href="#" className="foot">
                        Privacy Policy
                      </a>
                      <a href="/faq.html" className="foot">
                        Risk Disclosure
                      </a>
                      <a href="/terms.html" className="foot">
                        Terms & Conditions
                      </a>
                        <a href="/kyc" className="foot">
                   Kyc
                      </a>
                    </div>
                  </div>
                </div>
                <div className="text-center mt-5">
                  <img
                    src="/home/logo-payments.png"
                    className="small-image"
                    alt="Payment Methods"
                  />
                </div>
                <div className="text-center mt-4">
                  <p className="footer-credit">
                    ©2024, TRUE LEDGER ASSIST - ALL RIGHTS RESERVED.
                  </p>
                </div>
                {/* <div className="text-center mt-4">
                  <div className="d-flex justify-content-center col-5 col-lg-3">
                    <div>
                      <img src="/home/award001.png" width="80%" alt="Award 1" />
                    </div>
                    <div>
                      <img src="/home/award002.png" width="80%" alt="Award 2" />
                    </div>
                    <div>
                      <img src="/home/award003.png" width="80%" alt="Award 3" />
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
            <div
              style={{
                position: "fixed",
                left: 0,
                bottom: 0,
                zIndex: 1,
                width: "100%",
              }}
            >
              <div
                style={{
                  width: "100%",
                  backgroundColor: "#FFFFFF",
                  overflow: "hidden",
                  boxSizing: "content-box",
                  textAlign: "right",
                  lineHeight: "14px",
                  fontSize: "12px",
                  fontFeatureSettings: "normal",
                  textSizeAdjust: "100%",
                  padding: "0px",
                  margin: "0px",
                }}
              >
                <div style={{ height: "40px" }}>
                  <iframe
                    src="https://widget.coinlib.io/widget?type=horizontal_v2&theme=light&pref_coin_id=1505&invert_hover="
                    width="100%"
                    height={36}
                    scrolling="auto"
                    marginWidth={0}
                    marginHeight={0}
                    frameBorder={0}
                    border={0}
                    style={{ border: 0, margin: 0, padding: 0 }}
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
